<template><select v-bind="$attrs" :value="currentValue" class="custom-select" @change="onChange"><slot></slot></select></template>
<script lang="ts">
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'BFormSelect',
  inheritAttrs: false,
  props: { modelValue: { default: undefined }, value: { default: undefined } },
  emits: ['update:modelValue', 'input', 'change'],
  setup(props, { emit }) {
    const currentValue = computed(() => props.modelValue ?? props.value)
    const onChange = (event: Event) => {
      const target = event.target as HTMLSelectElement
      const option = target.options[target.selectedIndex] as HTMLOptionElement & {
        _value?: unknown
      }
      const value = Object.prototype.hasOwnProperty.call(option, '_value')
        ? option._value
        : target.value
      emit('update:modelValue', value)
      emit('input', value)
      emit('change', value)
    }
    return { currentValue, onChange }
  }
})
</script>
